import { createFileRoute } from '@tanstack/react-router';
import { Seo } from '../$portalId/-components/seo';
import { useLingui } from '@lingui/react/macro';
import { Layout } from './-components/layout';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { getLegalContentFn } from '@/lib/server-functions-portal';

export const Route = createFileRoute('/www/legal-disclaimer')({
	loader: ({ context }) => getLegalContentFn({ data: { type: 'legal-disclaimer', locale: context.locale } }),
	component: Component,
});

function Component() {
	const { t } = useLingui();
	const html = Route.useLoaderData();

	return (
		<Layout>
			<Header />
			<Seo
				title={t`Legal Notice - Worldcoo`}
				description={t`Legal Notice regulating the use of the service of the website owned by WORLDCOO S.L.`}
			/>

			<article className="unreset-tailwind mx-auto max-w-4xl p-8" dangerouslySetInnerHTML={{ __html: html }} />

			<Footer />
		</Layout>
	);
}
